module.exports = __webpack_public_path__ + "static/media/evier-white.36ce7373.svg";